<template>
    <div class="Bid" v-if="lang">
        <div class="table table-mobile table--office table--bid has-status">
            <md-button v-if="addButton" class="md-icon-button md-raised button" @click.native="addBid">
                <md-icon>add</md-icon>
            </md-button>
            <md-button v-else class="md-icon-button md-raised button-remove" @click.native="removeBids">
                <md-icon>clear</md-icon>
            </md-button>
            <md-table-card v-if="bids.length > 0" class="table--wrap">
                <md-table md-sort="name" @sort="onSort" md-sort-by="name" @select="onSelect">
                    <md-table-header>
                        <md-table-row>
                            <md-table-head class="td-sort-name center-md" md-sort-by="office_id">{{translate.pages.bids.index.fields.office}}</md-table-head>
                            <md-table-head class="hidden-md" md-sort-by="date">{{translate.pages.bids.index.fields.discount_date}}</md-table-head>
                            <md-table-head class="hidden-md" md-sort-by="time">{{translate.pages.bids.index.fields.discount_time}}</md-table-head>
                            <md-table-head class="hidden-md">{{translate.pages.bids.index.fields.speciality}}</md-table-head>
                            <!--<md-table-head class="hidden-md dto-td" v-for="prevision in previsions" :key="prevision.key">{{ prevision.display_name }}</md-table-head>
                            <md-table-head class="hidden-md">{{translate.pages.bids.index.fields.status}}</md-table-head>
                            <md-table-head class="hidden-md text-center">{{translate.pages.bids.index.fields.actions}}</md-table-head>-->
                        </md-table-row>
                    </md-table-header>
                    <md-table-body>
                        <md-table-row v-for="(row, rowIndex) in bids" :key="rowIndex" :md-item="row" md-selection>
                            <md-table-cell class="bidname">
                                <span class="bid-name">{{ row.office.name }}</span>
                            </md-table-cell>
                            <md-table-cell class="datetime">
                                <div class="bid-item">
                                    <h5 class="visible-md">{{translate.pages.bids.index.fields.discount_date}}</h5>
                                    <span>{{ row.date }}</span>
                                </div>
                                <div class="bid-item visible-md inline">
                                    <h5>{{translate.pages.bids.index.fields.discount_time}}</h5>
                                    <span>{{ row.time }}</span>
                                </div>
                            </md-table-cell>
                            <md-table-cell class="bid-row descuentos">
                                <div class="bid-item bid-time-item hidden-md">
                                    <span>{{ row.time }}</span>
                                </div>
                                <div class="bid-item visible-md inline" v-for="prevision in row.previsions" v-if="prevision.pivot" :key="prevision.id">
                                    <h5>{{ prevision.display_name }}</h5>
                                    <span>{{ prevision.pivot.percentage | formatPercentage }}</span>
                                </div>
                            </md-table-cell>
                            <md-table-cell class="bid-row descuentos">
                                <div class="bid-item bid-time-item hidden-md">
                                    <span>{{ row.speciality.name }}</span>
                                </div>
                            </md-table-cell>
                            <md-table-cell class="hidden-md" v-for="prevision in row.previsions" v-if="prevision.pivot"  :key="prevision.id">
                                <h5>{{ prevision.display_name }}</h5>
                                <span>{{ prevision.pivot.percentage | formatPercentage }}</span>
                            </md-table-cell>
                            <md-table-cell class="static-md status-td">
                                <div class="used-icon used" :class="{ 'available': !row.used }"></div>
                            </md-table-cell>
                            <!-- <md-table-cell class="actions" style="width: 40px">
                                <md-icon class="icon-edit raised" @click.native="openDialog('edit', row, rowIndex)">edit</md-icon> 
                                <md-icon class="icon-delete raised" @click.native="remove(row, rowIndex)">delete</md-icon>
                            </md-table-cell>-->
                        </md-table-row>
                    </md-table-body>
                </md-table>
            </md-table-card>
            <div v-else>
                <h3>
                    <span class="not-found mini-found" v-if="fetchData">Aún no ha agregado ofertas.</span>
                    <span v-else>
                        <div class="sk-rotating-plane"></div>
                    </span>
                </h3>
            </div>
        </div>
    </div>
</template>
<script>
    const swal = require('sweetalert2');
    import { doctor } from '../../../config/api.js';
    import axios from 'axios';
    export default {
        data: () => ({
            bids: [],
            offices: [],
            currentBid: {},
            errors: {
                'office': {
                    'invalid': false,
                    'msg': ''
                },
                'date': {
                    'invalid': false,
                    'msg': ''
                },
                'time': {
                    'invalid': false,
                    'msg': ''
                },
                'fonasa': {
                    'invalid': false,
                    'msg': ''
                },
                'isapre': {
                    'invalid': false,
                    'msg': ''
                },
                'particular': {
                    'invalid': false,
                    'msg': ''
                },
                'speciality': {
                    'invalid': false,
                    'msg': ''
                },
                'response': {
                    'invalid': false,
                    'msg': ''
                }
            },
            selectedData: [],
            fetchData: false,
            currentIndex: -1,
            close: false,
            addButton: true,
            process: false,
        }),
        created() {
            let url = doctor.api.bids;
            let parent = this.$auth.getParent();
            if(parent)
            {
                url += '?parent=' + parent;
            }
            // Get bids
            this.$http.get(url,{
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    this.bids = response.data.data;
                    this.fetchData = true;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
            // Get previsions by country
            this.$http.get('/previsions?countryCode=' + this.$route.params.country)
                .then(response => {
                    let data = response.data.data;
                    this.previsions = data;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
        },
        computed: {
            // Get language
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get lang
            lang(){
                return this.$store.getters.language.lang;
            }
        },
        methods: {
            // Route add Bid
            addBid() {
                this.$router.push({'name': 'BidAdd'});
            },
            // Validate addButton
            onSelect(data) {
                this.selectedData = data;
                this.$forceUpdate();
                (_.size(this.selectedData) >= 1) ? this.addButton = false : this.addButton = true;
            },
            // Sort table
            onSort(sort) {
                this.bids = _.orderBy(this.bids, [item => item[sort.name]], sort.type);
            },
            // Remove Bid
            remove(row, rowIndex){
                swal(this.translate.pages.bids.swal.remove.title, this.translate.pages.bids.swal.remove.message, 'warning')
                    .then( () => {
                        let url = doctor.api.bids + '/' + row.id;
                        let parent = this.$auth.getParent();
                        if(parent)
                        {
                            url += '?parent=' + parent;
                        }
                        this.$http.delete(url,{
                                    headers: {
                                        Authorization : 'Bearer '+ this.$auth.getToken(),
                                    }
                            }).then(response => {
                                let data = response.data.data;
                                swal('', response.data.msg, 'success')
                                    .then( () => {
                                        this.bids.splice(rowIndex, 1);
                                    }, (dismiss) => {
                                        this.bids.splice(rowIndex, 1);
                                    });
                            }).catch(error => {
                                console.log(error);
                            });
                    }, (dismiss) => {
                        //console.log(dismiss);
                    });
            },
            // Remove Bids
            removeBids(){
                swal(this.translate.pages.bids.swal.remove_offices.title, this.translate.pages.bids.swal.remove_offices.message, 'warning')
                    .then( () => {
                        var promises = [];
                        for(let index in this.selectedData)
                        {
                            let url = doctor.api.bids + '/' + this.selectedData[index].id;
                            let parent = this.$auth.getParent();
                            if(parent)
                            {
                                url += '?parent=' + parent;
                            }
                            promises.push(this.$http.delete(url, {
                                            headers: {
                                                Authorization : 'Bearer '+ this.$auth.getToken(),
                                            }
                                        }));
                        }
                        Promise.all(promises)
                            .then(values => {
                                var msg = '';
                                var quantites = 0;
                                values.forEach( response => {
                                    if(response.status == 200)
                                    {
                                        msg = response.data.msg;
                                        quantites++;
                                        let url = response.config.url;
                                        let id = url.split("/bids/")[1];
                                        this.bids.forEach( (office,index) => {
                                            if(office.id == id){
                                                this.bids.splice(index,1);
                                            }
                                        });
                                    }else{
                                        // Not deleted
                                    }
                                });
                                swal('', quantites + msg.substring(1), 'success')
                                    .then( () => {
                                        this.selectedData = [];
                                        this.addButton = true;
                                    }, (dismiss) => {
                                        this.selectedData = [];
                                        this.addButton = true;
                                    });
                            });
                    }, (dismiss) => {
                        //console.log(dismiss);
                    });
            }
        }
    }
</script>
<style lang="stylus" scoped>
    @import '../../../assets/styles/variables/color.styl'
    @import '../../../assets/styles/loading.styl'
    .Bid
        .search
            display flex
            padding 1em
            .icon
                text-align center
                width 50px
            .input
                width 100%
                input
                    border 0
                    height 2em
                    width 100%
            .button
                background-color color_main
                color white
                position absolute
                right 1em
                top 2.45em
                &:hover
                    background-color color_main
                    color white
            .button-remove
                background-color color_error
                color white
                position absolute
                right 1em
                top 2.45em
                &:hover
                    background-color color_error
                    color white
            .status
                color color_form_placeholder
                font-size 1.5em
                left 0.35em
                position absolute
                top 0.75em
        .table
            padding 3em 2em 2em 2em
            .img
                border-radius 50%
            .name
                margin-left .5em
            .text-center
                text-align center
            .icon-edit
                color color_notifications
                cursor pointer
                font-size 22px
            .icon-delete
                color color_error
                cursor pointer
                font-size 22px
            .enabled
                border 1px solid color_form_placeholder
                border-radius 1em
                color color_form_placeholder
                margin 0 auto
                padding 0.5em 1.5em
                text-align center
                width 110px
                &.active
                    border 1px solid color_confirm
                    color color_confirm
            .button
                background-color color_main
                color white
                position absolute
                right 0.5em
                top 6em
                z-index 5
                &:hover
                    background-color color_main
                    color white
            .button-remove
                background-color color_error
                color white
                position absolute
                right 1.5em
                top 7em
                z-index 100
                &:hover
                    background-color color_error
                    color white
            .used
                background-color red
                border-radius 49%
                border 2px solid color_form_placeholder
                cursor pointer
                height 12px
                width 100px
                visibility hidden
                &.available
                    background-color white
            .used:after
                content 'Utilizada'
                visibility visible
                display block
                position relative
                top -8px
                width 100px
                color #FFF !important
                background-color #818a9a
                padding 4px 3px
                border-radius 30px
                text-align center
            .used.available:after
                    content 'Disponible'
                    background-color color_green

    .content-main
        .container
            padding 0.25em 1em
            .picture
                position relative
                .icon
                    background-color color_main
                    border 3px solid white
                    border-radius 50%
                    bottom -1em
                    cursor pointer
                    height 40px
                    padding 8px
                    position absolute
                    right -1em
                    width 40px
                    text-align center
                    i
                        color white
                        position relative
                        left -3px
                        top -3px
            .multiple
                border 1px solid color_form_border
                border-radius 5px
                width 100%
                .title
                    margin 0.5em
                    color color_form_placeholder
                .select
                    overflow-y scroll
                    overflow-x hidden
                    margin 0.25em
                    height 110px
                    .option
                        width 95%
                        margin 0.25em
            .subtitle
                margin-top .5em
                color color_form_placeholder
    @import '../../../assets/styles/responsive.styl'
</style>


// WEBPACK FOOTER //
// Index.vue?38d079d6